import { iframeResizer } from "iframe-resizer";

$(function() {
  const pardotIframe = $("#pardot-iframe");
  if (pardotIframe) {
    iframeResizer(
      {
        log: false,
        checkOrigin: false,
        heightCalculationMethod: "max",
        onResized(data) {
          data.fontSize = parseFloat(window ? window.getComputedStyle(document.body).getPropertyValue("font-size") : 16);
          data.iframe.iFrameResizer.sendMessage(data);
        },
      },
      "#pardot-iframe"
    );

    const search = new URLSearchParams(window ? window.location.search : "");

    search.append("Referrer", document.referrer || (window ? window.location.href : ""));
    search.append("Website_URL", window ? window.location.href : "https://burstsms.com");
    search.append("Website_Source", "Burst US");

    pardotIframe.attr('src',pardotIframe.attr('src')+ "?" + search.toString());
  }
});
